import { NgModule } from '@angular/core'
import { UrlMatchResult } from '@angular/router'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { FlexLayoutModule } from '@angular/flex-layout'

import { AuthModule } from './auth/auth.module'
import { DataModule } from './data/data.module'
import { ComponentsModule } from './components/components.module'
import { MaterialModule } from './material/material.module'
import { PipesModule } from './pipes/pipes.module'

import { NavService } from './services/nav.service'
import { InjectorService } from './services/injector.service'

import { AutoResizeTextAreaDirective } from './directives/auto-resize-text-area.directive'
import { StepsFixedStepperDirective } from './directives/steps-fixed-stepper.directive'
import { RegexpMatcher } from './regexpMatcher';

@NgModule({
  declarations: [
    AutoResizeTextAreaDirective,
    StepsFixedStepperDirective,
  ],
  exports: [
    AuthModule,
    DataModule,
    ComponentsModule,
    MaterialModule,
    PipesModule,

    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,

    AutoResizeTextAreaDirective,
    StepsFixedStepperDirective,
  ],
  providers: [
    NavService,
    InjectorService,
  ]
})
export class FrameworkModule {
  static regexpMatch (segments, group, route): UrlMatchResult {
    return RegexpMatcher.matcher(segments, route)
  }

  static initialize(): any {}
}
